/**
 * De stand van de AI-chatbot, op één plek.
 *
 * Twee sloten moeten allebei open: de omgevingsvariabele op de server (vraagt
 * een herstart) en de knop in Settings. Het scherm moet dat verschil kunnen
 * laten zien — anders staat iemand te klikken op een schakelaar die toch niets
 * doet omdat de server het niet toelaat.
 */
import { useApi } from './useApi'

export interface AiStand {
  effective: boolean
  env_enabled: boolean
  switch_enabled: boolean
  chat_live: boolean
  conversations_total: number
  conversations_ai_on: number
}

export function useAiStand() {
  return useApi<AiStand>('/api/admin/ai-control')
}

/** Waarom de bot stil staat, in één zin. Leeg als hij gewoon aan staat. */
export function redenUit(s: AiStand | null | undefined): string {
  if (!s) return ''
  if (s.effective) return ''
  if (!s.env_enabled && !s.switch_enabled) {
    return 'The switch is off and the server does not allow it '
      + '(AI_AUTOREPLY_MASTER is missing).'
  }
  if (!s.env_enabled) {
    return 'The server does not allow it: AI_AUTOREPLY_MASTER is off. '
      + 'That needs a worker restart.'
  }
  return 'The switch in Settings is off.'
}
